/**
 * 判断当前 path 是否为以 https:// 或者 http:// 开头的 url
 * @param path
 * @return {boolean}
 */
function isURL(path) {
  return /https:\/\/|http:\/\//.test(path);
}

/**
 * 判断当前 path 是否为 base64 字符串
 * @param path
 */
function isBase64(path) {
  return /^(data:image)/.test(path);
}
/**
 * 返回图片 url
 * 1、Path 模式时自动支持 Path；
 * 2、自动判断图片的路径是相对路径还是 URL；
 * 3、支持内部资源、外部资源以及 Base64；
 * @param path
 * @param withPublicPath img路径域名是否带上PUBLIC_PATH
 */
export function getImagePath(path, withPublicPath = true) {
  const PUBLIC_PATH = process.env.PUBLIC_PATH || '';
  if (isURL(path) || isBase64(path)) {
    return path;
  }
  return withPublicPath && PUBLIC_PATH ? `${PUBLIC_PATH}${path}` : path;
}
